export const bottleTag = process.env.REACT_APP_ENVIRONMENT === "development" ? process.env.REACT_APP_BOTTLE_TAG : window.__env?.REACT_APP_BOTTLE_TAG;

export const gtmId = process.env.REACT_APP_ENVIRONMENT === "development" ? process.env.REACT_APP_GTM_ID : window.__env?.REACT_APP_GTM_ID;